// extracted by mini-css-extract-plugin
export var form = "fcb30d9445568b6035452afbf234b596-css";